import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '@/core/service/user.service';
import { environment } from '@/../environments/environment';
import { AtividadeDetalhe } from './models/atividade-detalhe';
import { AtividadeRelacao } from './models/atividade-relacao';
import { AtividadeListServico } from './models/atividade-list-servico';


declare global {
  interface Navigator {
    msSaveBlob: (blob: Blob, fileName?: string) => boolean;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AtividadeService {
  private environmentUrl: string = '';
  atividadeSearch = new EventEmitter();
  atividadeEvents = new EventEmitter();

  constructor(private httpClient: HttpClient, private userService: UserService) {
    this.environmentUrl = environment.ApiCore;
  }

  getRelacaoAtividade(
    idHierarquia: number,
    matriculaTecnico: string,
    numeroBa: string,
    numeroBaOriginal: string,
    equipeResponsavel: string,
    idAtividadeStatus: number,
    idAcionamentoTipo: string,
    idAtividadeTipo: number[],
    idAcionamento: string,
    idProvisorio: string,
    dataEncerrado: Date,
    numeroDocumento: string,
    pagina: number,
    totPag: number
  ): Observable<AtividadeRelacao[]> {
    const params = {
      IdAtividade: null,
      IdEmpresa: this.userService.getIdEmpresa(),
      IdUsuario: this.userService.getUserId(),
      IdHierarquia: idHierarquia === undefined || idHierarquia == null ? null : idHierarquia,
      DataStatusOs: null,
      MatriculaTecnico: matriculaTecnico,
      NumeroBa: numeroBa == '' ? null : numeroBa,
      NumeroBaOriginal: numeroBaOriginal == '' ? null : numeroBaOriginal,
      CodTipoAtividade: null,
      IdAtividadeStatus: idAtividadeStatus,
      IdAtividadeTipo: idAtividadeTipo == null ? null : idAtividadeTipo.join(','),
      IdAtividadeClassificacao: null,
      Descricao: null,
      EquipeResponsavel: equipeResponsavel == '' ? null : equipeResponsavel,
      MatriculaImovel: null,
      TipoAtendimento: null,
      Endereco: null,
      IdentificadorCliente: null,
      DataEncerramento: dataEncerrado,
      IdAcionamentoTipo: idAcionamentoTipo,
      ID: idAcionamento,
      IdProvisorio: idProvisorio,
      NumeroDocumento: numeroDocumento,
      Pagina: pagina,
      TotPag: totPag,
    };

    const url = this.environmentUrl + 'Atividade/GetRelacaoAtividade';
    return this.httpClient.post<AtividadeRelacao[]>(url, params);
  }


  findAtividadeById(idAtividade: number) {
    const idUsuario = this.userService.getUserId();
    const idEmpresa = this.userService.getIdEmpresa();

    const url =
      this.environmentUrl +
      'atividade/mobile/v1.0/DetalheAtividade/' +
      idUsuario +
      '/' +
      idEmpresa +
      '/' +
      idAtividade;

    return this.httpClient.get<AtividadeDetalhe>(url);
  }


  ////////

  getListServico(body: any): Observable<AtividadeListServico[]> {
    return this.httpClient.post<AtividadeListServico[]>(
      this.environmentUrl + 'atividade/mobile/v1.0/RelacaoAtividade',
      body
    );
  }

  updateCoordenadas(payload: any): Observable<any> {
    const url = this.environmentUrl + 'atividade/AtualizaCoordenadas';
    return this.httpClient.put(url, payload);
  }

    exportExcel(body: any){
  let url = `${this.environmentUrl}atividade/mobile/v1.0/RelacaoAtividadeExcel`;
  return this.httpClient.post(url, body, { responseType: 'text' });
  }
}
